<template>
  <div class="bs-10-001 container mx-auto w-full mb-4">
    <div class="lg:w-full" style="background: #E5E5E5;">
      <div class="l-container">
        <div class="w-full md:w-full h-2/3 pt-4">
          <div class="f24-36 sm:mt-6">
            ロープライス・ギャランティー規約
          </div>
        </div>
      </div>
      <div class="w-full pt-5">
        <div style="border: solid 1px #DCDEE0"> </div>
      </div>

      <div class="l-container sm:pt-8 mt-12">
        <div class="w-full" style="background: #FFFFFF; border-radius: 10px;">
          <div class="grid grid-cols-1 m-auto w-11/12 md:pt-8">
            <div class="f16-24-2 lg:pt-0 md:pt-0 pt-11 text-center">
              下記のロープライス・ギャランティー規約について、同意の上お申し込みください。
              <br>ロープライス・ギャランティー規約
            </div>
            <div class="f18-27 my-3 sm:mt-0">
              <span class="f20-30" style="color: #222222">1.ロープライス・ギャランティー申請</span>
            </div>
            <div class="f14-21">
              ①申請は「Beneオリジナル」ロゴが表示されているプランでの予約成立が条件となります。
            </div>
            <div class="f14-21">
              また比較対象プランに空室が有り、予約可能な状態であることが申請の条件となります。
            </div>
            <div class="f14-21">
              ※比較対象プランが満室の場合は申請及び審査の対象とはなりません。
            </div>
            <div class="f14-21">
              ②申請は予約成立直後の受付となりますので、予めご了承ください。
            </div>
            <div class="f14-21">
              ※申請フォームはWEBで予約完了後、所定の手続きを進めて頂くと表示されます。それ以外の場合は、カスタマーセンターまでお問合せください。
            </div>
            <div class="f14-21">
              ※申請期限は利用日前日の18：00迄となります。
            </div>
            <div class="f14-21">
              ※利用日前日の18：00以降及び利用日当日の申請は、審査の対象とはなりません。
            </div>
            <div class="f14-21">
              ③インターネット媒体以外の申請(広告・新聞等・チラシ・パンフレット等紙媒体)をご希望の場合は、原本の郵送もしくはFAXが必要となります。
            </div>
            <div class="f14-21">
              ④申請は同一グループ（同一宿泊者）での予約記録に対して、1回のみとなります。
            </div>
            <div class="f14-21">
              ⑤同じ宿泊日での、他施設の申請は受付ておりません。
            </div>
             <div class="f14-21">
              ※同一施設での重複予約中の申請も受付ておりません。
            </div>
            <div class="f14-21">
              ⑥利用日間近での利用の場合、即キャンセルチャージ対象となる場合がございますのでご注意ください。
            </div>
            <div class="f14-21">
              又審査及び、適用対象外の場合でも、予約は継続となります。
            </div>
             <div class="f14-21">
              ※弊社にて比較対象プランをお選びすることはございませんので、予めご了承ください。
            </div>
            <div class="f14-21">
              ⑧ＷＥＢ申請は予約成立直後のみとなりますので、予めご了承ください。
            </div>
            <div class="f14-21">
              ※申請フォームはWEBで予約完了後、所定の手続きを進めて頂くと表示されます。
            </div>
             <div class="f14-21">
              電話での申請もご予約成立直後の受付のみとなります。ご予約完了後にお申し出ください。
            </div>
            <div class="f14-21">
              ※電話での受付は10：00～21：00となりますが、18：00以降の申請は翌営業時間10：00～18：00での審査となります。
            </div>
            <div class="f14-21">
              なおカスタマーセンターへご連絡頂いた際の申請についても、本規約に同意されたものとみなします。
            </div>
            <div class="f14-21">
              ⑨日本国以外の法人による運営サイトに掲載されているプランについては、その表示言語が日本語で且つ日本円で掲載されている場合に限ります。
            </div>
            <div class="f14-21">
              また表示料金が為替相場により変動する場合においては、弊社確認時での料金で審査させていただきますので、予めご了承ください。
            </div>
            <div class="f14-21">
              ※その他審査及び対象外規定については、本規約に則っとり準用いたします。
            </div>

            <div class="f18-27 mt-6 mb-3 sm:mt-0">
              <span class="f20-30" style="color: #222222">2.ロープライス・ギャランティー審査</span>
            </div>
            <div class="f14-21">
              ①申請内容を弊社にて確認を行いますが、料金やプラン内容が一致しない場合や、比較対象プランを確認できなかった場合は、審査の対象とならない場合がございまので、予めご了承ください。
            </div>
            <div class="f14-21">
              ②プランによっては料金が変動するプランもございます。その場合は弊社確認時の料金で審査させていただきますので、予めご了承ください。
            </div>
            <div class="f14-21">
              ③申請された比較対象プランが、Beneオリジナルプランの場合は審査対象となりません。
            </div>
            <div class="f14-21">
              ④宿泊プランは料理内容やお部屋の位置など多様でございますので、プラン内容の確認に時間がかかる場合がございます。
            </div>
            <div class="f14-21">
              ⑤審査は専属部署にて、本規定に沿い厳正に行います。
            </div>

            <div class="f18-27 mt-6 mb-3 sm:mt-0">
              <span class="f20-30" style="color: #222222">3.審査による対象外規定</span>
            </div>
            <div class="f14-21">
              以下掲載するケースについてはロープライス・ギャランティー適用の対象外となりますので、予めご了承ください。
            </div>
            <div class="f14-21">
              ※下記は一例でございます。宿泊プランは様々な種類がございますので、審査または適用の対象とならない場合もございます。
            </div>
            <div class="f14-21">
              ①販売形態
            </div>
            <div class="f14-21">
              (1)募集型企画旅行プラン　<br>※個人フリータイプ含め全てのツアープラン
            </div>
            <div class="f14-21">
              (2)宿泊前に決済（事前支払）が必要なプラン　<br>※オンラインによるクレジットカード決済や銀行振込等
            </div>
             <div class="f14-21">
              (3)日本国以外の宿泊施設利用
            </div>
            <div class="f14-21">
              (4)コーポレート契約や有料制会員サイト掲載プラン、その他プロモーション向けプラン
            </div>
            <div class="f14-21">
              (5)宿泊を伴わない全てのプラン　<br>※日帰り(デイユース)プランなど
            </div>
            <div class="f14-21">
              (6)個室客室の利用がない宿泊プラン　<br>※リラクゼーションルーム利用等
            </div>
            <div class="f14-21">
              (7)キャッシュバックプラン
            </div>
            <div class="f14-21">
              (8)販売・予約が利用日当日限定のプラン
            </div>
            <div class="f14-21 pb-2">
              (9)クーポンやチケット等の共同購入を目的とした割引販売をしているサイト
            </div>
            <div class="f14-21">
              ②予約内容と比較対象プランに相違がある場合
            </div>
            <div class="f14-21">
              (1)予約客室と比較対象プランの客室に相違が有る場合
            </div>
            <div class="f14-21">
              (例1)客室種類の相違　和室と洋室の相違など
            </div>
            <div class="f14-21">
              (例2)グレードの相違　広さやベットサイズ、眺望や階層の相違など
            </div>
            <div class="f14-21">
              ※客室手配が「施設お任せ」など、最終的な客室手配内容が同一の客室条件となる可能性が存在する場合はこの限りではない。
            </div>
            <div class="f14-21">
              (2)食事の条件に相違が有る場合
            </div>
            <div class="f14-21">
              (例1)2食付の予約に対して、食事無のプランで申請等
            </div>
            <div class="f14-21">
              (例2)食事形態が会席とバイキングで相違が有る場合
            </div>
            <div class="f14-21">
              (例3)同一のお食事スタイルであっても、そのグレード(内容)に差異が有る場合
            </div>
            <div class="f14-21">
              (3)利用者人数で申込ができないプラン
            </div>
            <div class="f14-21">
              (例)大人3名からの予約条件に対し、利用者が大人2名の場合
            </div>
            <div class="f14-21">
              (4)利用客室数と、予約可能な客室数とが一致しない場合
            </div>
            <div class="f14-21">
              (例)2室以上からの予約受付に対し、1室利用の場合など
            </div>
            <div class="f14-21">
              (5)泊数に制限のあるプランで、且つ利用内容と一致しない場合
            </div>
            <div class="f14-21">
              (例1)1泊利用に対して連泊プランでの申請
            </div>
            <div class="f14-21">
              (例2)連泊利用に対して1泊限定プランでの申請
            </div>
            <div class="f14-21 pb-2">
              (例3)同じ泊数利用だが、何れかの日程で満室の為予約できない場合
            </div>
            <div class="f14-21">
              ③予約に関して特定の申込制限があるプラン
            </div>
            <div class="f14-21">
              (1)利用者の在住地が限定されている場合
            </div>
            <div class="f14-21">
              (2)学生限定・シニア等年齢制限のある場合
            </div>
            <div class="f14-21">
              (3)男性及び女性等性別制限のある場合
            </div>
              <div class="f14-21">
              (4)バースデイプラン
            </div>
            <div class="f14-21">
              (5)モニター料金プラン（宿泊後に体験レポート提出や、クチコミ・ツイッター投稿等を義務付けることが条件）
            </div>
            <div class="f14-21">
              (6)公共交通機関等、交通手段を限定している場合
            </div>
            <div class="f14-21">
              (7)有料無料に関わらず、予約に際し各種入会手続きが必要な場合　<br>※ホテルメンバーズカード等
            </div>
            <div class="f14-21">
              (8)子供受入不可プラン
            </div>  
            <div class="f14-21">
              (9)ペット同伴不可の場合
            </div>
            <div class="f14-21">
              (10)滞在時間に制限が有り、利用と副わない場合
            </div>
            <div class="f14-21">
              (11)期間限定のタイムセール等、予約受付が終了しているプラン
            </div>
            <div class="f14-21">
              (12)予約受付に早期締切の制限や、予約成立後の変更・CXLが原則行えないプラン　<br>※早割りなど
            </div>
            <div class="f14-21 pt-2">
              ④その他　審査の対象外及び適用外のケース
            </div>
            <div class="f14-21">
              (1)各社固有の提供サービスや特典・金券は適用外となります。
            </div>
            <div class="f14-21">
              (2)各プラン固有の特典・金券は適用外となります。
            </div>
            <div class="f14-21">
              (3)ビジター様の利用料金は適用外となります。
            </div>
            <div class="f14-21">
              (4)現地直接予約や提携外手配に対する申請は受付けておりません。
            </div>
            <div class="f14-21">
              (5)連続7泊以上、7泊目からの宿泊は対象外となります。
            </div>
            <div class="f14-21">
              (6)掲載・設定ミス等、施設の意図に反した販売がなされていた場合は適用外となります。
            </div>
            <div class="f14-21">
              (7)添い寝等施設使用料や宿泊に伴う各種諸税は適用外となります。
            </div>
            <div class="f14-21">
              (8)比較対象プランの合計料金が、弊社利用料金より高い場合は審査の対象外となります。
            </div>
            <div class="f14-21">
              (9)比較対象プランが満室の場合　<br>※比較対象プランの利用日が除外日の場合も該当します。
            </div>
            <div class="f14-21">
              (10)決済が日本円以外の場合
            </div>
            <div class="f14-21 pt-4">
              最終更新日: 2014年3月12日
            </div>

          </div>
          <div class="mt-16 pb-8">
            <div class="buttons flex gap-2 justify-center mt-8 sm:flex-col-reverse sm:items-center">
              <button @click="handleBack()" style="min-width:150px" class="c-btn btn-white btn-white-width sm:w-9/12 ">
                <span class="">同意しない</span>
              </button>
              <button @click="handleNext()" style="min-width:150px" class="c-btn btn-grey sm:w-9/12 ">
                <span class="">同意する</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  SAVE_AGREE_TERM_LOW_PRICE
} from '@/store/modules/bs_app/actions'
export default {
  name: 'bs_app_03_001',
  components: {
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    handleNext() {
      const query = this.$route.query
      const dataTerm = {
        agreeTerm: true
      }
      this.$store.dispatch(SAVE_AGREE_TERM_LOW_PRICE, dataTerm).then(() => {
        this.$router.push({path: '/low-price', query})
      })

    },
    handleBack() {
      const dataTerm = {
        agreeTerm: false
      }
      this.$store.dispatch(SAVE_AGREE_TERM_LOW_PRICE, dataTerm).then(() => {})
      this.$router.go(-1)
    },
    redirectTo() {
      window.open('https://bs.benefit-one.co.jp/BE-ONE/official/handling.html')
    }
  }
}
</script>

<style scoped>
@import "./styles.scss";
</style>